<k-dialog v-if="modalShow" :class="modalClass" :title="modalTitle" @close="close">
    <slot name="content" />
    <dialog-actions-bar>
        <slot name="footer" />
    </dialog-actions-bar>
</k-dialog>